import { updateAuthInformation } from './auth-slice';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type LoanDecisionsState = Record<string, 'ACCEPTED' | 'REFUSED'>;

const getInitialState = (): LoanDecisionsState => ({});

const initialState = getInitialState();

const loanDecisionsSlice = createSlice({
  name: 'loanDecisions',
  initialState,
  reducers: {
    setLoanDecision(state, action: PayloadAction<{ customerId: string; decision: 'ACCEPTED' | 'REFUSED' }>) {
      state[action.payload.customerId] = action.payload.decision;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAuthInformation, (state, action) => {
      if (typeof action.payload === 'undefined') {
        return getInitialState();
      }

      return state;
    });
  },
});

export const { reducer: loanDecisionsReducer } = loanDecisionsSlice;
export const { setLoanDecision } = loanDecisionsSlice.actions;
